export default __webpack_public_path__ + "static/right-7065defe71c7a09989643c81973aaade.png";